export function fakeDeviationResponse(): any {
  if (process.env.NODE_ENV !== 'production') {
    const { deviationsByType } = require('@wix/da-sample-data'); // eslint-disable-line global-require
    return {
      deviation: { ...deviationsByType.deviations[0] },
    };
  }
}

function makePcpResponse(): any {
  const downloadDollarPrice = Math.ceil(Math.random() * 50) + 1;
  const downloadPrice = downloadDollarPrice * 80;
  return {
    downloadPrice,
    downloadDollarPrice,
    hasUserPurchased: false,
    zipFilesize: 80839123,
    url: 'https://www.deviantart.com/pointsdownload/modal/display?deviationid=436649341',
    assets: [
      {
        deviationId: 1,
        type: 'jpeg',
        filename: 'somefile.jpg',
        filesize: 1500,
        width: 300,
        height: 150,
      },
      {
        deviationId: 2,
        type: 'jpeg',
        filename: 'some other file.jpg',
        filesize: 78000,
        width: 1980,
        height: 1297,
      },
      {
        deviationId: 3,
        type: 'pdf',
        filename: 'big file.pdf',
        filesize: 693200024,
      },
    ],
  };
}

export function fakeInitResponse(options): any {
  if (process.env.NODE_ENV !== 'production') {
    const { deviationsByType, galleries } = require('@wix/da-sample-data'); // eslint-disable-line global-require
    const deviations = [...deviationsByType.image, ...deviationsByType.film];
    const { word, url } = require('@wix/da-sample-data/dist/src/helpers'); // eslint-disable-line global-require
    const { makeEditorTextWithOptions } = require('@wix/da-sample-data/dist/src/fakes/editorText'); // eslint-disable-line global-require
    const deviationid = options?.params?.deviationid;
    const deviationIndex = deviations.findIndex(d => d.deviationId === deviationid);
    const isEdit = deviationIndex > -1;
    const deviation = isEdit ? deviations[deviationIndex] : { ...deviations[0], title: '' };
    return {
      deviation,
      tiers: deviationsByType.tiers.slice(0, 10),
      galleries: galleries.slice(0, 8),
      published: isEdit,
      description: !isEdit
        ? makeEditorTextWithOptions({
            legacy: false,
            words: 0,
            sentences: 0,
          })
        : makeEditorTextWithOptions({
            legacy: false,
            words: 6,
            sentences: 4,
          }),

      pcp: !isEdit ? undefined : makePcpResponse(),
      inTiers: isEdit ? deviationsByType.tiers.slice(0, 2) : [],
      inGalleries: isEdit ? galleries.slice(0, 2) : [],
      tags: isEdit ? new Array(5).fill(undefined).map(_ => ({ name: word(), url: url() })) : [],
    };
  }
}

export function fakeTierResponse(options): any {
  if (process.env.NODE_ENV !== 'production') {
    const { deviationsByType } = require('@wix/da-sample-data'); // eslint-disable-line global-require
    const { word, url } = require('@wix/da-sample-data/dist/src/helpers'); // eslint-disable-line global-require
    const { makeEditorTextWithOptions } = require('@wix/da-sample-data/dist/src/fakes/editorText'); // eslint-disable-line global-require
    const deviationid = options?.params?.deviationid;
    const deviationIndex = deviationsByType.image.findIndex(d => d.deviationId === deviationid);
    const deviation = deviationsByType.image[deviationIndex];
    return {
      deviation,
      published: true,
      description: makeEditorTextWithOptions({
        legacy: false,
        words: 6,
        sentences: 4,
      }),
      tags: new Array(5).fill(undefined).map(_ => ({ name: word(), url: url() })),
      tier: {
        settings: {},
      },
    };
  }
}
